import { FC, Suspense, lazy } from "react";
import { useEffect } from "react";
import { Navigate, useNavigate, Route, Routes } from "react-router-dom";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import { WithChildren } from "../../_metronic/helpers";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import { HomePage } from "../pages/Homepage/HomePage";
import { MenuTestPage } from "../pages/MenuTestPage";
import { DashboardWrapper } from "../pages/dashboard/DashboardWrapper";
import { localStorageItem } from "../../app/modules/utils/LocalStorage";

const PrivateRoutes = () => {
  const navigate = useNavigate();

  // Nutri Care Modules
  const NutriMealSlotManagement = lazy(() => import("../modules/nutri-meal-slots"));
  const NutriMealManagement = lazy(() => import("../modules/nutri-meal"));
  const NutriMenuManagement = lazy(() => import("../modules/nutri-menu"));
  const NutriMealRegistrationList = lazy(() => import("../modules/nutri-meal/components/NutriMealRegistrationList"));
  const NutriMealRegistrationPivot = lazy(() => import("../modules/nutri-meal/components/NutriMealRegistrationPivot"));
  const NutriMealDistribution = lazy(() => import("../modules/nutri-meal/components/NutriMealDistribution"));
  const DistributionSummaryDashboard = lazy(() => import("../modules/nutri-meal/components/DistributionSummaryDashboard"));


  return (
    <Routes>
      <Route path="/*" element={<Navigate to="/nutri-meal-slots" replace />} />
      <Route path="home" element={<HomePage />} />
      <Route element={<MasterLayout />}>
        <Route path="auth/*" element={<Navigate to="/home" />} />
        <Route path="dashboard" element={<DashboardWrapper />} />
        <Route path="menu-test" element={<MenuTestPage />} />


        {/* ========== NUTRI CARE - QUẢN LÝ DINH DƯỠNG ========== */}

        {/* Nutri Meal Slot Management - Quản lý khung giờ ăn */}
        <Route
          path="nutri-meal-slots"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <NutriMealSlotManagement />
            </Suspense>
          }
        />

        {/* Nutri Meal Management - Quản lý suất ăn */}
        <Route
          path="nutri-meals"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <NutriMealManagement />
            </Suspense>
          }
        />

        {/* Nutri Meal Registration Pivot - Đăng ký suất ăn theo bảng pivot */}
        <Route
          path="nutri-meal-registrations-pivot"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <NutriMealRegistrationPivot />
            </Suspense>
          }
        />

        {/* Nutri Meal Distribution - Phát suất ăn */}
        <Route
          path="nutri-meal-distribution"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <NutriMealDistribution />
            </Suspense>
          }
        />

        {/* Nutri Daily Menu - Thực đơn theo ngày */}
        <Route
          path="nutri-daily-menu"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <NutriMenuManagement />
            </Suspense>
          }
        />

        {/* Distribution Summary Dashboard - Báo cáo phát suất */}
        <Route
          path="nutri-distribution-summary"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <DistributionSummaryDashboard />
            </Suspense>
          }
        />

        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>

  );
};
export { PrivateRoutes };

